var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalaryReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/receipt-edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M68.8332 38.1665V23.9665C68.8332 10.5332 65.6998 7.1665 53.0998 7.1665H27.8998C15.2998 7.1665 12.1665 10.5332 12.1665 23.9665V61.4998C12.1665 70.3665 17.0332 72.4665 22.9332 66.1332L22.9665 66.0998C25.6998 63.1998 29.8665 63.4331 32.2331 66.5998L35.5998 71.0998",
    stroke: "#C02842",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.1665 23.8335H53.8332",
    stroke: "#C02842",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.5 37.1665H50.5",
    stroke: "#C02842",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M61.2035 49.7343L49.4036 61.5343C48.9369 62.0009 48.5035 62.8676 48.4035 63.5009L47.7702 68.001C47.5369 69.6343 48.6702 70.7677 50.3036 70.5343L54.8036 69.901C55.4369 69.801 56.3369 69.3676 56.7702 68.9009L68.5703 57.101C70.6036 55.0677 71.5703 52.701 68.5703 49.701C65.6036 46.7343 63.2368 47.7009 61.2035 49.7343Z",
    stroke: "#C02842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M59.4976 51.4341C60.4976 55.0341 63.2976 57.8341 66.8976 58.8341",
    stroke: "#C02842",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaryReport);
export default __webpack_public_path__ + "static/media/salary_report.42606092b79e404b0f83c79cf1e1d53f.svg";
export { ForwardRef as ReactComponent };